<div fxLayoutAlign="center center" class="social-media-container">
    <div fxFlex="60" fxFlex.md="70" fxFlex.sm="80" fxFlex.xs="95">
        <div fxLayout="row">
            <div fxFlex>
                <ul class="social-links">
                    <li class="facebook">
                        <mat-label matTooltip="Facebook">
                            <a target="_blank" href="https://www.facebook.com/uwconline1/"><i class="fa fa-facebook"></i></a>
                        </mat-label>
                    </li>
                    <li class="youtube">
                            <mat-label matTooltip="Youtube">
                                <a target="_blank" href="https://www.youtube.com/user/uwconline"><i class="fa fa-youtube"></i></a>
                            </mat-label>
                        </li>
                    <li class="twitter">
                        <mat-label matTooltip="Twitter">
                            <a target="_blank" href="https://twitter.com/UWCONLINE"><i class="fa fa-twitter"></i></a>
                        </mat-label>
                    </li>
                    <li class="linkedin">
                        <mat-label matTooltip="LinkedIn">
                            <a target="_blank" href="https://www.linkedin.com/school/uwc/"><i class="fa fa-linkedin"></i></a>
                        </mat-label>
                    </li>
                    <li class="flickr">
                        <mat-label matTooltip="Flickr">
                            <a target="_blank" href="https://www.flickr.com/photos/77301206@N06/"><i class="fa fa-flickr"></i></a>
                        </mat-label>
                    </li>
                </ul>
            </div>
            <!--
            <div fxFlex="100px" fxLayoutAlign="end center">
                <mat-label class="mat-tooltip-help" matTooltip="Help: This will be removed if there is no help document" matTooltipPosition="left">
                    <a href="#"><mat-icon>help</mat-icon></a>
                </mat-label>
            </div>
            -->
        </div>
    </div>
</div>
<div fxLayoutAlign="center center" class="top-navigation-container">
    <div fxLayout="column" fxFlex="60" fxFlex.md="70" fxFlex.sm="80" fxFlex.xs="95">
        <div fxLayout="row">
            <div fxFlex="220px">
                <div class="logo">
                    <a href="https://www.uwc.ac.za" target="_blank"><img src="../../../assets/logos/uwc.jpg"></a>
                </div>
            </div>
            <div fxFlex fxLayoutAlign="end center">
                <div class="top-menu-wrap" fxHide.lt-md>
                    <nav>
                        <ul class="primary">
                            <li>
                                <a href="https://nsfas.org.za" target="_blank">NSFAS</a>
                            </li>
                            <li>
                                <a href="https://www.uwc.ac.za/admission-and-financial-aid/fees-and-financial-aid/financial-aid-forms-templates" target="_blank">Fin Aid</a>
                            </li>
                            <li>
                                <a href="https://www.uwc.ac.za/apply-now" target="_blank">Online Applications</a>
                            </li>
                            <li>
                                <a href="https://www.uwc.ac.za/study/faculties-and-programmes" target="_blank">Faculties <i class="menu-down-arrow"></i></a>
                                <ul class="sub">
                                    <li>
                                        <a target="_blank" href="https://www.uwc.ac.za/study/faculties-and-programmes/faculty-of-arts-and-humanities/overview">Faculty of Arts</a>
                                    </li>
                                    <li>
                                        <a target="_blank" href="https://www.uwc.ac.za/study/faculties-and-programmes/faculty-of-community-and-health-sciences/overview">Faculty of Community and Health Sciences</a>
                                    </li>
                                    <li>
                                        <a target="_blank" href="https://www.uwc.ac.za/study/faculties-and-programmes/faculty-of-dentistry/overview">Faculty of Dentistry</a>
                                    </li>
                                    <li>
                                        <a target="_blank" href="https://www.uwc.ac.za/study/faculties-and-programmes/faculty-of-education/overview">Faculty of Education</a>
                                    </li>
                                    <li>
                                        <a target="_blank" href="https://www.uwc.ac.za/study/faculties-and-programmes/faculty-of-economic-and-management-sciences/overview">Faculty of Economic and Management Sciences</a>
                                    </li>
                                    <li>
                                        <a target="_blank" href="https://www.uwc.ac.za/study/faculties-and-programmes/faculty-of-law/the-deans-message">Faculty of Law</a>
                                    </li>
                                    <li>
                                        <a target="_blank" href="https://www.uwc.ac.za/study/faculties-and-programmes/faculty-of-natural-sciences/overview">Faculty of Natural Sciences</a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <a href="https://www.uwc.ac.za/admission-and-financial-aid/fees-and-financial-aid" target="_blank" >Student Finance</a>
                            </li>
                            <li>
                                <a href="https://www.uwc.ac.za" target="_blank">Contact</a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div fxHide fxShow.lt-md class="mobile-menu-button-wrap">
                    <button mat-button class="mobile-menu-button" (click)="toggleMobileMenu()">
                        <mat-icon>{{opened ? 'close' : 'menu'}}</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>